module.exports = __webpack_public_path__ + "img/representation.e5492be8.svg";